import { Charts } from './Charts';
import ResultsChartsDataProvider from './contexts/ResultsChartsDataContext';

const ResultsWrapper = () => {
    return (
        <ResultsChartsDataProvider>
            <Charts />
        </ResultsChartsDataProvider>
    );
};

export default ResultsWrapper;
